// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function immutable(constructor) {
    return class extends constructor {
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        constructor(...args) {
            super(...args);
            Object.freeze(this);
        }
    };
}
